import { Theme as ThemeMUI } from '@material-ui/core'
import { createStyles, makeStyles } from '../../../../UI/MaterialUI'

export default makeStyles((theme: ThemeMUI) =>
  createStyles({
    root: {
      width: '100%',
      marginBottom: '16px',
    },
    label: {
      fontFamily: 'LatoBold',
      marginBottom: '8px',
    },
    datePickerWrapper: {
      maxWidth: '320px',
      marginBottom: '8px',
    },
    checkboxesContainer: {
      display: 'flex',
      flexDirection: 'row',
      gap: '16px',
    },
    required: {
      color: 'inherit',
    },
    requiredError: {
      color: 'red',
    },
  })
)
